import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';

interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgArrowDownCircleIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path d="M22.535 16.88 16.879 22.54c-.24.24-.568.31-.879.25-.311.06-.639-.01-.879-.25L9.465 16.88a1.001 1.001 0 0 1 1.414-1.42L15 19.59V9a1 1 0 1 1 2 0v10.59l4.121-4.13a1.001 1.001 0 0 1 1.414 1.42ZM16 0C7.163 0 0 7.16 0 16s7.163 16 16 16 16-7.16 16-16S24.837 0 16 0Z" />
    </g>
  </svg>
);

const ForwardRef = forwardRef(SvgArrowDownCircleIcon);
export default ForwardRef;
